import { useEffect, useState } from 'react';
import API from './axios';

// Fetch changelogs and expose the loading state alongside them.
export const useChangelogs = () => {
  const [changelogs, setChangelogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/changelogs')
      .then((res) => setChangelogs(res.data.messages || []))
      .catch((err) => {
        console.error('Error fetching changelogs:', err);
        setChangelogs([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return { changelogs, loading };
};

export const useChangelogsTimestamps = () => {
  const [timestamps, setTimestamps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/changelogs')
      .then((res) => {
        const changelogs = res.data.messages || [];
        setTimestamps(changelogs.map((log) => log.timestamp).slice(0, 3));
      })
      .catch((err) => {
        console.error('Error fetching changelogs:', err);
        setTimestamps([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return { timestamps, loading };
};

// Utility function to capitalize names
export const capitalizeName = (name) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};

// Utility function to parse Discord message content
export const parseMessageContent = (content) => {
  content = content.replace(/@everyone/g, ' ');
  content = content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>'); // Bold
  content = content.replace(/\*(.*?)\*/g, '<em>$1</em>'); // Italic
  content = content.replace(/__(.*?)__/g, '<u>$1</u>'); // Underline
  // content = content.replace(/\n/g, '<br>'); // Line breaks
  content = content.replace(/<@(\d+)>/g, '@User'); // Mentions
  content = content.replace(
    /https?:\/\/[^\s]+/g,
    '<a href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
  ); // Links
  content = content.replace(
    /<a?:(\w+):(\d+)>/g,
    (match, name, id) =>
      `<img src="https://cdn.discordapp.com/emojis/${id}.png" alt="${name}" style="width: 20px; height: 20px;" />`
  ); // Emojis
  content = content.replace(/```/g, ''); // Remove code block markers
  content = content.replace(/ansi/g, ''); // Remove ANSI markers
  return content;
};
